import { IEditor } from '../interface/editor';
import { IForm } from '../interface/form';

export class TForm implements IForm {
  editors: { [key: string]: IEditor } = {};

  constructor(public element: HTMLFormElement
  ) {
    this.element.onsubmit = (ev: SubmitEvent) => {
      this.internalOnsubmit(ev);
    };
  }

  get value(): any {
    const allValue: any = {};
    this.getEditorsArray().forEach(e => {
      allValue[e.name] = e.value;
    });
    return allValue;
  }

  setEditors(editors: IEditor[]): void {
    this.editors = {};
    if (editors) {
      editors.forEach(e => {
        this.editors[e.name] = e;
      });
    }
  }

  internalOnsubmit(ev: SubmitEvent): void {
    let isValid = true;
    let isPending = false;
    this.getEditorsArray().forEach(editor => {
      editor.validate();
      if (editor.isValid === false) {
        isValid = false;
      }
      if (editor.isPending === true) {
        isPending = true;
      }
    });
    if (isPending) {
      ev.preventDefault();
      //wait until complete
      const intervalRef = setInterval(() => {
        let stillPending = false;
        let stillValid = true;
        this.getEditorsArray().forEach(editor => {
          if (editor.isPending === true) {
            stillPending = true;
          }
          if (editor.isValid === false) {
            stillValid = false;
          }
        });
        if (stillPending === false && stillValid ===true) {
          clearInterval(intervalRef);
          //resubmit
          const subEv = new SubmitEvent('submit', {
            submitter: this.element,
            bubbles: true,
            cancelable: true
          });
          this.onSubmit(subEv);
          if (!subEv.defaultPrevented) {
            this.submit();
          }
        }
      }, 200);
    } else if (!isValid) {
      ev.preventDefault();
      this.focusToFirstErrorField();
    }
    else {
      this.onSubmit(ev);
    }
  }

  submit(): void {
    this.element.submit();
  }

  onSubmit = (ev: SubmitEvent): void => { };

  focusToFirstErrorField(): void {
    setTimeout(() => {
      const ele = this.element;
      if (ele) {
        const firstErrorField = ele.querySelector(".form-input.is-invalid .focusable") as HTMLElement;
        if (firstErrorField) {
          firstErrorField.focus();
        }
      }
    }, 200);
  }

  setValue(value: { [fieldName: string]: any }): void {
    this.clean();
    this.patchValue(value);
  }

  patchValue(value: { [fieldName: string]: any }): void {
    this.getEditorsArray().forEach(e => {
      if (value[e.name] !== undefined) {
        e.value = value[e.name];
      }
    });
  }

  clean(): void {
    this.getEditorsArray().forEach(e => {
      e.value = null;
    });
  }

  get(fieldName: string): IEditor | null {
    const editor = this.editors[fieldName];
    if (editor) {
      return editor;
    }
    return null;
  }

  private getEditorsArray() {
    return Object.keys(this.editors).map(ek => this.editors[ek]);
  }
}
